var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuccessCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88px",
    height: "89px",
    viewBox: "0 0 88 89",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AF31842E-7AFB-40D1-AB0F-BC3937BB628E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PWS-APP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "API-Admin---New-Key-4",
    transform: "translate(-676.000000, -117.000000)",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dialog",
    transform: "translate(468.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content-Area"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(24.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration/Check",
    transform: "translate(186.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#002C8B",
    points: "21.84 46.0370149 32.88 57.5462687 60.48 28.7731343"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#00B5E1",
    cx: 42,
    cy: 42.3134328,
    rx: 42,
    ry: 42.3134328
  }))))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheck);
export default __webpack_public_path__ + "static/media/Success_Check.b1493f53.svg";
export { ForwardRef as ReactComponent };